import { Tab } from '@mui/icons-material'
import cn from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ContentTabs from '../contenttabs/ContentTabs'
import TabItem from '../tabitem/TabItem'
import FtWallet from '../wallet/FtWallet'
import Wallet from '../wallet/Wallet'
import UserStats from './UserStats'
import { useSharedState } from '../waxplorer/Waxplorer'

export const UserControlPanel = ({ user, tab }) => {
    const [tabKey, setTabKey] = useState(tab)

    const { t } = useTranslation('common')
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const myProfile = user === userName

    return (
        <div
            className={cn(
                'border dark:!bg-paper bg-white rounded-md shadow-xl',
                'dark:!border-paperl border-zinc-200 p-4 w-full h-full pb-auto',
            )}
        >
            {myProfile ? (
                <ContentTabs
                    bg={''}
                    tabKey={tabKey}
                    onSelect={(k) => setTabKey(k)}
                >
                    <Tab
                        eventKey="overview"
                        title={
                            <TabItem
                                tabCount={3}
                                target={'overview'}
                                tabKey={tabKey}
                                title={t('landing.overview')}
                                size={'small'}
                            />
                        }
                    >
                        <UserStats userName={user} />
                    </Tab>
                    <Tab
                        eventKey="wallet"
                        title={
                            <TabItem
                                tabCount={3}
                                target={'wallet'}
                                tabKey={tabKey}
                                title={t('general.wallet')}
                                size={'small'}
                            />
                        }
                        tabClassName={'h-full'}
                    >
                        {tabKey === 'wallet' && <Wallet />}
                    </Tab>
                    <Tab
                        eventKey="fungibles"
                        title={
                            <TabItem
                                tabCount={3}
                                target={'fungibles'}
                                tabKey={tabKey}
                                title={t('overview.ft_assets')}
                                size={'small'}
                            />
                        }
                        tabClassName={'h-full'}
                    >
                        {tabKey === 'fungibles' && <FtWallet />}
                    </Tab>
                </ContentTabs>
            ) : (
                <UserStats userName={user} />
            )}
        </div>
    )
}
